import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PdfApiService {
  private readonly endpoint = `${environment.backendApi}/api/generate-pdf/`;

  constructor(private http: HttpClient) {}

  /**
   * Generates a PDF document from the claim form single view page
   * @returns Observable<Blob> - PDF file as binary data
   */
  generatePdf(): Observable<Blob> {
    const token = localStorage.getItem('jwt');

    if (!token) {
      throw new Error('JWT token not found. Please authenticate first.');
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.post(this.endpoint, {}, {
      headers,
      responseType: 'blob'
    });
  }

  /**
   * Downloads the generated PDF file
   * @param filename - Optional filename for the download (default: 'physical_proof.pdf')
   */
  downloadPdf(filename: string = 'physical_proof.pdf'): void {
    this.generatePdf().subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('PDF generation failed:', error);
        throw error;
      }
    });
  }
}
